import { render, staticRenderFns } from "./ExecReferrals.vue?vue&type=template&id=5ec8d4a6"
import script from "./ExecReferrals.vue?vue&type=script&lang=js"
export * from "./ExecReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports